import Hero from './components/Hero';
import Features from './components/Features';
import HowToUse from './components/HowToUse';
import Reviews from './components/Reviews';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import PageSEO from '@/components/base/PageSEO';

const pageSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '17c',
  url: 'https://guanghua2020.cn',
  description: '17c是一款备受关注的效率工具平台，提供数据管理、团队协作、自动化工作流等核心功能。',
  foundingDate: '2020',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-000-1700',
    email: 'contact@guanghua2020.cn',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export default function Home() {
  return (
    <PageSEO
      title="17c官方落地页 - 17c平台介绍与功能指南 | 17c官网"
      description="17c是一款备受关注的平台/产品，本页全面介绍17c的核心功能、使用方法、用户评价及常见问题，帮助你快速了解17c的价值与优势，立即探索17c带来的全新体验。"
      keywords="17c,17c官网,17c下载,17c使用教程,17c功能介绍,17c用户评价,17c常见问题"
      canonicalPath="/"
      schema={pageSchema}
    >
      <div className="fade-in-up">
        <Hero />
      </div>
      <div className="fade-in-up fade-in-up-delay-1">
        <Features />
      </div>
      <div className="fade-in-up fade-in-up-delay-2">
        <HowToUse />
      </div>
      <div className="fade-in-up fade-in-up-delay-3">
        <Reviews />
      </div>
      <div className="fade-in-up fade-in-up-delay-4">
        <FAQ />
      </div>
      <CTA />
    </PageSEO>
  );
}